<template>
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.9501 102.58C40.5502 102.58 45.0901 98.0402 45.0901 92.44C45.0901 86.8398 40.5502 82.3 34.9501 82.3C29.3499 82.3 24.8101 86.8398 24.8101 92.44C24.8101 98.0402 29.3499 102.58 34.9501 102.58Z"
      fill="#CB80DE"
    />
    <path
      d="M98.5301 102.58C104.13 102.58 108.67 98.0402 108.67 92.44C108.67 86.8398 104.13 82.3 98.5301 82.3C92.93 82.3 88.3901 86.8398 88.3901 92.44C88.3901 98.0402 92.93 102.58 98.5301 102.58Z"
      fill="#CB80DE"
    />
    <path
      d="M110.05 67.89H106.47C106.33 67.32 106.11 66.75 105.76 66.21L93.45 47.04C92.47 45.51 90.77 44.58 88.94 44.58H76.76V38.23C76.76 31.47 71.28 26 64.53 26H20.23C13.48 25.99 8 31.47 8 38.22V76.46C8 83.22 13.48 88.69 20.23 88.69H110.05C115.8 88.69 120.45 84.03 120.45 78.29C120.45 72.54 115.79 67.89 110.05 67.89Z"
    />
    <path
      d="M79.1699 67.89H106.95L97.5799 53.47C96.9499 52.65 96.0499 52.16 93.5399 52.16H79.1599C77.7799 52.16 76.6599 53.16 76.6599 54.39V65.68C76.6599 66.91 77.7799 67.91 79.1599 67.91L79.1699 67.89Z"
      fill="#CB80DE"
    />
  </svg>
</template>

<script>
  export default {
    name: 'CompanyInsurance'
  }
</script>
